import React from 'react';
import Tooltip from './Tooltip';
/**
 * A common label component
 * @param props.name The name of the field the label exists for
 * @param props.label The label to display
 * @param props.tooltipText Text to display in a tooltip
 * @param props.labelCssClass Extra CSS class(es) to add to the label
 * @param props.isRequired An element to note if the field is required or not
 */
const Label = (props) => (React.createElement("label", { htmlFor: props.name, className: `${props.labelCssClass} control-label` },
    props.isRequired,
    props.label,
    " \u00A0",
    React.createElement(Tooltip, { text: props.tooltipText, name: props.name })));
export default Label;
